import thunk from 'redux-thunk'
import adminReducer from "./adminReducer";
import userReducer from "./userReducer";
import vendorReducer from "./vendorReducer";
import driverReducer from "./driverReducer";
import flightReducer from "./flightReducer";
import sharedReducer from "./sharedReducer";
import calculateTotal from "./calculateTotal";
import searchHistory from "./searchHistory";
import { createLogger } from 'redux-logger';
import {createStore,combineReducers,applyMiddleware,compose} from "redux";
import uiReducer from './uiReducers';


var middleware = [thunk]

if (process.env.NODE_ENV === 'development') {
 middleware.push(createLogger());
}
const initialState = {}

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;


const reducers = combineReducers({
  admin: adminReducer,
  user: userReducer,
  vendor: vendorReducer,
  driver: driverReducer,
  shared: sharedReducer,
  ui:uiReducer,
  price: calculateTotal,
  flight: flightReducer,
  searchHistory:searchHistory
});

const enhancer = composeEnhancers(applyMiddleware(...middleware));
const store = createStore(reducers, initialState, enhancer);
export default store
